import { render, staticRenderFns } from "./ReadyCardsDialog.vue?vue&type=template&id=8aa1ce24"
import script from "./ReadyCardsDialog.vue?vue&type=script&lang=js"
export * from "./ReadyCardsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports